import { connect } from 'react-redux';
import {
  fetchInventoryLocations,
  deleteInventoryLocation
} from '../../../redux/Inventory/sagas/location/routines';
import {
  getIsFetching,
  getIsDeleting,
  getIsDeleted,
  getOrder
} from '../../../redux/Inventory/selectors/location';
import {
  clearInventoryLocations,
  inventoryLocationsOnChangePage,
  inventoryLocationsOnChangeOrder
} from '../../../redux/Inventory/actions/location';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageLocation
} from '../../../redux/Inventory/selectors/location/pagination';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import paginationAndSearchQuery from '../../../helpers/paginationAndSearchQuery';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';
import InventoryLocationList from '../../../components/inventory/LocationList';
import orderList from '../../../helpers/orderList';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getSearchQueryForContext(state, SEARCH_CONTEXT.ITEM);
  const order = getOrder(state);
  return {
    locations: orderList(order, getCurrentPageLocation(state)),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getIsFetching(state),
    isDeleting: getIsDeleting(state),
    isDeleted: getIsDeleted(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchInventoryLocations());
    },
    onDelete: tag => {
      dispatch(deleteInventoryLocation(tag));
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchInventoryLocations(query));
      else dispatch(inventoryLocationsOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearInventoryLocations());
      dispatch(fetchInventoryLocations(query));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      dispatch(clearInventoryLocations());
      dispatch(fetchInventoryLocations({ ...query, order }));
      dispatch(inventoryLocationsOnChangeOrder(order));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryLocationList);
